<template>
  <v-row justify="center">
    <Dialog origin="top center" commonDialog="ViewCreateAddon" :max-width="dialogWidth" content-class="customer-dialog"
      persistent>
      <template v-slot:title>
        <div class="d-flex">
          <h1 class="form-title text-truncate">
            {{ addon === 0 ? "Create" : "Update" }} Add-On
          </h1>
          <v-chip label v-if="barcode" color="chip-custom-blue" outlined class="text-white p-3 ml-4"
            style="font-size: 21px !important; font-weight: 700">
            <template>
              {{ barcode }}
            </template>
          </v-chip>
        </div>
      </template>
      <template v-slot:body>
        <v-form ref="AddOneForm" v-model.trim="formValid" lazy-validation v-on:submit.stop.prevent="onSubmit">
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <!-- Name -->
                <v-row class="mb-4">
                  <v-col cols="12">
                    <label class="text-subtitle-2 font-weight-bold required">Name</label>
                    <TextField v-model="addonArr.name" dense filled solo flat placeholder="Name"
                      :rules="[validateRules.required(addonArr.name, 'Name')]" counter="50" />
                  </v-col>
                </v-row>

                <!-- Price & Tax -->
                <v-row class="mb-4" dense>
                  <v-col cols="12" md="6">
                    <label class="text-subtitle-2 font-weight-bold required">Price</label>
                    <v-text-field v-model="addonArr.price" type="number" dense filled solo flat placeholder="Price"
                      :rules="[
                        validateRules.maxLength(addonArr.price, 'price', 10),
                        validateRules.decimalValidation(
                          addonArr.price,
                          'price'
                        ),
                      ]" />
                  </v-col>
                  <v-col cols="6" md="3">
                    <label class="text-subtitle-2 font-weight-bold "></label>
                    <v-checkbox v-model="addonArr.sqft_required" class="mt-2 ml-2 dense-checkbox" color="cyan">
                      <template v-slot:label>
                        <span class="ml-2">SQFT Price Required</span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="6" md="3" v-if="addonArr.sqft_required">
                    <label class="text-subtitle-2 font-weight-bold ">SQFT Limit</label>
                    <v-text-field v-model="addonArr.sqft_limit" type="number" dense filled solo flat
                      placeholder="SQFT Limit" :rules="[
                        validateRules.maxLength(addonArr.price, 'price', 10),
                        validateRules.decimalValidation(
                          addonArr.sqft_limit,
                          'price'
                        ),
                      ]" />
                  </v-col>

                  <!-- <v-col cols="12" md="6">
                    <div class="flex-grow-1">
                      <label class="text-subtitle-2 font-weight-bold">Duration</label>
                      <div class="d-flex align-items-center gap-2">

                        <v-text-field v-model="addonArr.duration" type="number" dense filled solo flat
                          placeholder="Duration" :rules="[
                            validateRules.decimalValidation(addonArr.duration, 'duration'),
                          ]" />
                        <div style="width: 180px;">
                          <v-select :items="options.duration" v-model="addonArr.duration_type" dense filled solo flat
                            color="cyan" item-text="value" item-value="value" placeholder="Duration Type" />
                        </div>
                      </div>

                    </div>

                  </v-col> -->
                  <!-- <v-col cols="12" md="6">
                    <label class="text-subtitle-2 font-weight-bold">Tax</label>
                    <v-select
                      :items="options.tax_type"
                      v-model="addonArr.tax"
                      dense
                      filled
                      solo
                      flat
                      color="cyan"
                      item-text="value"
                      item-value="value"
                      placeholder="Tax"
                    />
                  </v-col> -->
                </v-row>

                <!-- Duration & Quantity -->
                <!-- <v-row class="mb-4" dense> -->


                <!-- <v-col cols="12" md="6">
                    <label class="text-subtitle-2 font-weight-bold">Maximum Quantity</label>
                    <v-text-field v-model="addonArr.quantity" type="number" dense filled solo flat placeholder="Qty"
                      :rules="[validateRules.maxLength(addonArr.quantity, 'quantity', 5), validateRules.validNumeric(addonArr.quantity, 0)]"
                      append-inner-icon="">
                      <template #append>
                        <div class="d-flex flex-column justify-center">
                          <v-btn icon @click="addonArr.quantity++" style="height: 12px; padding: 0">
                            <v-icon>mdi-chevron-up</v-icon>
                          </v-btn>
                          <v-btn icon @click="addonArr.quantity = Math.max(0, addonArr.quantity - 1)"
                            style="height: 12px; padding: 0;">
                            <v-icon>mdi-chevron-down</v-icon>
                          </v-btn>
                        </div>
                      </template>
</v-text-field>
</v-col> -->
                <!-- </v-row> -->

                <!-- Description -->
                <v-row class="mb-4">
                  <v-col cols="12">
                    <label class="text-subtitle-2 font-weight-bold">Description</label>
                    <TextAreaField v-model="addonArr.description" dense filled solo flat counter="200"
                      placeholder="Description" color="cyan" />
                  </v-col>
                </v-row>

                <!-- Documents -->
                <v-card flat class="custom-grey-border remove-border-radius mt-4">
                  <v-row>
                    <v-col cols="12">
                      <DocumentList v-model="addonArr.files" :document-type="docType" />
                    </v-col>
                  </v-row>
                </v-card>

                <!-- Optional: Hidden FileUpload Card -->
                <v-card v-if="false" flat class="custom-grey-border remove-border-radius mt-4">
                  <v-card-title class="headline grey lighten-4">
                    <h3 class="font-weight-700 custom-headline color-custom-blue">
                      Images & Attachments
                    </h3>
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <FileUpload v-model="addonArr.files" />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </template>
      <template v-slot:action>
        <div class="d-flex justify-end">
          <v-btn depressed v-on:click="closeDialog()" :disabled="formLoading"
            class="mx-2 custom-grey-border custom-bold-button">
            Cancel
          </v-btn>
          <v-btn depressed :disabled="!formValid || formLoading" :loading="formLoading"
            class="mx-2 custom-bold-button white--text" v-on:click="onSubmit" color="cyan">
            {{ getAction }} Add-On
          </v-btn>
        </div>
      </template>
    </Dialog>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
// import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import {
  QUERY,
  PUT,
  CLEAR_ERROR,
  GET,
} from "@/core/services/store/request.module";
import PropertyMixin from "@/core/plugins/property-mixin";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import DocumentList from "@/view/pages/DocumnetList";
import Dialog from "@/view/pages/partials/Dialog.vue";

export default {
  mixins: [CommonMixin, PropertyMixin, ValidationMixin],
  name: "property-create",
  title: "Create Oil Sample",
  data() {
    return {
      docType: 33,
      addonArr: {
        name: null,
        tax: null,
        duration: null,
        description: null,
        quantity: null,
        price: null,
        add_extra_price: null,
        hide_extra: null,
      },
      addon: 0,
      tabs: [
        {
          title: "Overview",
          icon: "mdi-phone",
          key: "overview",
          permission: "customer",
          status: true,
        },
        // {
        //   title: "Attachment",
        //   icon: "mdi-image",
        //   key: "attachments",
        //   permission: "customer",
        //   status: false,
        // },
      ],
      pageLoading: false,
      testPackage: [],
      barcode: null,
      options: {
        duration: null,
        tax_type: null,
      },
      propertyTab: null,
    };
  },
  props: {
    ViewCreateAddon: {
      type: Boolean,
      required: true,
      default: false,
    },
    dialogWidth: {
      type: String,
      required: false,
      default: "750px",
    },
    batch_id: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  components: {
    DocumentList,
    Dialog,
  },
  watch: {
    formValid(param) {
      if (param) {
        this.$store.dispatch(CLEAR_ERROR, {});
      }
    },
    addon(param) {
      if (param > 0) {
        this.getAddOn()
          .then((response) => {
            this.addonArr = response;
          })
          .catch((error) => {
            this.logError(error);
            this.$router.go(-1);
          })
          .finally(() => {
            this.pageLoading = false;
          });
      }
    },
  },
  methods: {

    closeDialog() {
      this.ViewCreateAddon = false;
      this.$emit("closeDialog", true);
    },
    afterSubmit(id) {
      this.$emit("afterSubmit", id);
    },
    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(QUERY, { url: "addons/options" })
        .then(({ data }) => {
          _this.options.tax_type = data.tax_type;
          _this.options.duration = data.duration;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    onSubmit() {
      const _this = this;
      if (!_this.$refs.AddOneForm.validate()) {
        return false;
      }
      _this.$store
        .dispatch(PUT, {
          url: "addons",
          data: { addon: _this.addonArr },
        })
        .then((response) => {
          _this.addonCreated = true;
          _this.closeDialog();
          _this.afterSubmit(response.data.id);
          _this.addon = response.data.id;
          _this.getAddOn();
          _this.$nextTick(() => { });
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.formLoading = false;
        });
      // }
    },
    getAddOn() {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(GET, { url: "addon/" + _this.addon })
            .then((response) => {
              resolve(response.data);
              // _this.$store.dispatch(SET_BREADCRUMB, [
              //   { title: "Oil Sample", route: "property" },
              //   { title: "Update" },
              // ]);
              _this.addonArr = response.data;
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  mounted() {
    const _this = this;
    _this.getOptions();
    // _this.$store.dispatch(SET_BREADCRUMB, [
    //   { title: "Oil Batch", route: "oilbatch" },
    //   { title: "Create" },
    // ]);
  },
  created() {
    const _this = this;
    _this.addon = _this.batch_id ?? 0;
    // _this.transformer = _this.lodash.toSafeInteger(
    //   _this.$route.query.transformer
    // );
    if (_this.customer <= 0) {
      _this.$router.go(-1);
    }
  },
  computed: {
    getAction() {
      if (this.addon) {
        return "Update";
      }
      return "Save";
    },
    getPropertyTitle() {
      const _this = this;
      if (_this.propertyArr && _this.propertyArr.barcode) {
        return " • " + _this.propertyArr.barcode;
      }
      return "";
    },
    CustomerID: {
      get() {
        return this.addonArr.customer_id != null
          ? Number(this.addonArr.customer_id)
          : null;
      },
      set(value) {
        this.addonArr.customer_id = value;
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.addonCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>
